export function isStage() {
  return process.env.REACT_APP_BUILD_ENVIRONMENT === "stage";
}

export function isProduction() {
  return process.env.REACT_APP_BUILD_ENVIRONMENT === "production";
}
